import { Tabs } from '@bynder/design-system';
import { IconAdd, IconMin } from '@bynder/icons';
import WidgetSettingsFooter from '../WidgetSettingsFooter';
import {
  getNewButton,
  useButtonWidgetMutations,
} from '../../../../../mutations/widgets/button';
import { useInspectorStore } from '../../../../../stores/inspectorStore';
import { useActiveWidget } from '../../../../../queries/guides';
import { ButtonWidget } from '../../../../../types';
import { generateUUID } from '../../../../../helpers/utils';
import { useTranslate } from '@bynder/localization';

const ButtonSettingsFooter = () => {
  const { translate } = useTranslate();
  const { addNewButtonToButtonWidget, removeButton } =
    useButtonWidgetMutations();
  const setWidgetSettings = useInspectorStore(s => s.setWidgetSettings);
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const buttonWidget = useActiveWidget() as ButtonWidget;
  const currentButtonIndex = widgetSettings?.widgetIndex;
  const currentButtonId = buttonWidget?.buttons[currentButtonIndex]?.id;
  const isLastButton = buttonWidget.buttons.length === 1;
  const currentButton = buttonWidget.buttons[currentButtonIndex];
  const newButton = {
    ...getNewButton(generateUUID()),
    style: currentButton.style,
  };

  const handleRemoveButton = () => {
    if (buttonWidget.buttons.length > 1) {
      setWidgetSettings({
        widgetIndex:
          currentButtonIndex === 0
            ? currentButtonIndex
            : currentButtonIndex - 1,
      });
      removeButton.mutate({
        buttonIndex: currentButtonIndex,
        buttonId: currentButtonId,
      });
    }
  };

  if (buttonWidget.isLegacy) {
    return <WidgetSettingsFooter />;
  }
  return (
    <WidgetSettingsFooter>
      <Tabs.Tab
        data-testid="button-add-button"
        label={translate('WIDGET_INSPECTOR.BUTTON_ADD_BUTTON')}
        isLabelHidden
        isDisabled={buttonWidget.buttons.length === 10}
        icon={<IconAdd />}
        isActive={false}
        onClick={() => {
          addNewButtonToButtonWidget.mutate({ newButton });
        }}
      />
      <Tabs.Tab
        data-testid="button-remove-button"
        label={translate('WIDGET_INSPECTOR.BUTTON_REMOVE_BUTTON')}
        isLabelHidden
        isDisabled={isLastButton}
        icon={<IconMin />}
        isActive={false}
        onClick={handleRemoveButton}
      />
    </WidgetSettingsFooter>
  );
};

export default ButtonSettingsFooter;
